module.exports = __webpack_public_path__ + "img/origin-player-video-bg.eff2d588.svg";